module.exports = __webpack_public_path__ + "img/location.6ec385a8.png";